module.exports = __webpack_public_path__ + "img/zc1.1f7c1bfb.png";